// js
import React from 'react';
import PropTypes from 'prop-types';
import SecurityDetailPPTX from '../../../containers/analytics/pptx/SecurityDetailPPTX';


const SecurityCriticalInadequateDetailPPTX = ({ data }) => {
  return (
    <SecurityDetailPPTX
      data={data}
      criticality='critical'
      adequacy='inadequate'
    />
  );
};

SecurityCriticalInadequateDetailPPTX.propTypes = {
  data: PropTypes.object
};

export default SecurityCriticalInadequateDetailPPTX;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/SecurityCriticalInadequateDetailPPTX.js